// Wire shape: kebab-case strings matching QuickCheckReasonApiDtoV1 on the backend.
export const quickCheckReasons = [
  "curious",
  "medication-change",
  "tired",
  "dizzy",
  "light-headed",
  "nausea",
  "decreased-fetal-movement",
  "other",
] as const

export type QuickCheckReasonApiDto = (typeof quickCheckReasons)[number]
export type QuickCheckReason = QuickCheckReasonApiDto
